import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Component that handles automatic scrolling when changing pages
 * @component
 * @description Scrolls to the top of the page when the route changes
 * @returns {null} Does not render anything
 */
const ScrollToTop = (): null => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop; 